'use client';

import { useEffect, useState } from 'react';
import ReactCardFlip from 'react-card-flip';
import { SvgArrow } from '@icons/designSystemIcons/SvgArrow';
import { SvgCheckCircle } from '@icons/designSystemIcons/SvgCheckCircle';
import { SvgCross } from '@icons/designSystemIcons/SvgCross';
import { SvgInfoCircle } from '@icons/designSystemIcons/SvgInfoCircle';
import { ProductRedirect } from '@utils/productRedirectUtils';
import { Quantifier } from 'app/(dashboard)/dashboard/(pages)/budgets/HighLightedProduct/Quantifier';
import {
  Operation,
  useCartStore,
} from 'app/(dashboard)/dashboard/(pages)/budgets/stores/userCartStore';
import { useSessionStore } from 'app/stores/globalStore';
import { CartItem, Product, ProductType } from 'app/types/product';
import { Button } from 'designSystem/Buttons/Buttons';
import { Flex } from 'designSystem/Layouts/Layouts';
import { Text } from 'designSystem/Texts/Texts';
import { useRouter } from 'next/navigation';

const HYDRAFACIAL_BULLETS = [
  [
    'Tratamiento de 30 minutos',
    'Limpieza profunda',
    'Peeling suave para eliminar las impurezas y las células muertas de la piel',
    'Eliminar los puntos negros y las obstrucciones de los poros',
    'Hidratación intensiva para nutrir y rejuvenecer la piel',
  ],
  [
    'Tratamiento de 45 minutos',
    'Todos los beneficios del <span class="font-semibold">Hydrafacial</span>',
    'Potenciador o booster personalizado ',
    'Terapia LED para estimular la producción de colágeno y lucir una piel más firme y luminosa',
  ],
  [
    'Tratamiento de 60 minutos',
    'Todos los beneficios del <span class="font-semibold">Hydrafacial Deluxe</span>',
    'Drenaje linfático para mejorar la circulación y eliminar toxinas',
  ],
];

export const SESSION_PRODUCTS_EXTRA_INFO = [
  // mesoterapia facial
  {
    id: 'f99d66b2-1b9f-4794-a539-08db4c1d52cc',
    title: 'Mesoterapia facial x1',
    description:
      'Rejuvenece la piel, reduce arrugas y mejora la hidratación mediante microinyecciones de vitaminas y minerales.',
  },
  {
    id: '988caf19-06a8-4918-90ae-4d2b310556b7',
    title: 'Mesoterapia facial x3',
    description:
      'Consigue un resultado más rejuvenecida y visiblemente más saludable.',
  },
  {
    id: '717cfca9-6814-4f63-918b-2346705b5bf1',
    title: 'Mesoterapia facial x5',
    description:
      'Pack recomendado para maximizar el efecto de las vitaminas y conseguir un resultado más duradero.',
  },
  {
    id: '3f5b1dd7-b220-4a0e-967b-f4e6faf0f882',
    title: 'Hydrafacial x1',
    bullets: HYDRAFACIAL_BULLETS[0],
  },
  {
    id: 'fbeaa4fb-861e-4439-887f-6076665f1026',
    title: 'Hydrafacial x3',
    bullets: HYDRAFACIAL_BULLETS[0],
  },
  {
    id: '8fc8c043-4510-46f4-8534-8c3b58654904',
    title: 'Hydrafacial x6',
    bullets: HYDRAFACIAL_BULLETS[0],
  },
  {
    id: '62403dad-846f-46cf-b4cc-7dae946e028e',
    title: 'Hydrafacial Deluxe x1',
    bullets: HYDRAFACIAL_BULLETS[1],
  },
  {
    id: '758c0016-9426-4825-842b-f33a398dfdc2',
    title: 'Hydrafacial Deluxe x3',
    bullets: HYDRAFACIAL_BULLETS[1],
  },
  {
    id: '631c8564-fe40-41fa-a339-f16aba3110ec',
    title: 'Hydrafacial Deluxe x6',
    bullets: HYDRAFACIAL_BULLETS[1],
  },
  {
    id: 'fd3469c0-90b3-4d17-848d-0aff2a3952fb',
    title: 'Hydrafacial Platinum x1',
    bullets: HYDRAFACIAL_BULLETS[2],
  },
  {
    id: '40a41135-3c21-41a2-9ec7-98fb3b51d62b',
    title: 'Hydrafacial Platinum x3',
    bullets: HYDRAFACIAL_BULLETS[2],
  },
  {
    id: 'aa85f692-a339-4327-993c-3338413e7a03',
    title: 'Hydrafacial Platinum x6',
    bullets: HYDRAFACIAL_BULLETS[2],
  },
  {
    id: '7f2e85f1-ff32-4f2b-8d48-4117e9e5b4c7',
    title: 'Microneedling x1',
    description:
      'Promueve la generación natural de colágeno y elastina para mejorar la calidad y textura de la piel.',
  },
  {
    id: '567f1e64-5421-42a8-8060-6440de76f303',
    title: 'Microneedling x3',
    description:
      'Consigue unos resultados más visibles con el pack de 3 sesiones gracias al efecto acumulativo del tratamiento.',
  },
  {
    id: 'a335dc73-2951-4dde-8298-f1ffeb83bd2e',
    title: 'Microneedling x6',
    description:
      'Recomendado para maximizar los resultados visibles del tratamiento con varias sesiones y conseguir un resultado más duradero.',
  },
  {
    id: '4600dfd3-edd6-4bb3-a355-25e32c54a01e',
    title: 'Peeling Químico x2',
    description: 'Suaviza arrugas moderadas, cicatrices, manchas y daño solar',
  },
  {
    id: '1c2d022e-851f-4c5f-bfea-ec7c61c012a8',
    title: 'Peeling Químico x3',
    description: 'Suaviza arrugas moderadas, cicatrices, manchas y daño solar',
  },
  {
    id: 'bbfdf8de-0486-4233-a2e4-7fe502f80904',
    title: 'Peeling Químico',
    description: 'Suaviza arrugas moderadas, cicatrices, manchas y daño solar',
  },
  {
    id: '2a7a2fd9-c6ba-413e-10a5-08db57826543',
    title: 'Rejuvenecimiento capilar x1',
    description: 'Fortalece tu cabello y reduce la caída',
  },
  {
    id: 'ae006262-2ef7-4a42-8845-0fde5a25ffcd',
    title: 'Rejuvenecimiento capilar x3',
    description:
      'Consigue un cabello visiblemente más sano a la vez que reduces la caída',
  },
  {
    id: 'caef14b6-b40e-4a86-ae57-56ff04db31b6',
    title: 'Rejuvenecimiento capilar x6',
    description:
      'Pack recomendado para maximizar la reducción de la caída del cabello a la vez que se consigue un aspecto saludable duradero',
  },
  {
    id: 'bb317525-8fe9-4373-9938-69e7f329fdad',
    title: 'Exosomas x1',
    description:
      'Activa la regeneración celular, para una piel más tersa, uniforme y rejuvenecida.',
  },
  {
    id: '0a1b11d9-b3dc-44a0-b833-919f344086cb',
    title: 'Exosomas x3',
    description:
      'Activa la regeneración celular, para una piel más tersa, uniforme y rejuvenecida.',
  },
];

export default function ProductSessionPriceCard({
  isDashboard = false,
  isGroupedSessionProduct = false,
  productItems,
  className = '',
}: {
  isDashboard?: boolean;
  isGroupedSessionProduct?: boolean;
  productItems: Product[];
  className?: string;
}) {
  const router = useRouter();
  const [productIndexToAdd, setProductIndexToAdd] = useState(0);

  const { cart, addItemToCart, removeSingleProduct, getQuantityOfProduct } =
    useCartStore(state => state);
  const {
    setSelectedTreatments,
    setBudgetId,
    cleanCheckoutSession,
    currentOrigin,
  } = useSessionStore(state => state);
  const [isFlipped, setIsFlipped] = useState<boolean>(false);
  const [flipMessage, setFlipMessage] = useState<string>('');
  const [cardHeight, setCardHeight] = useState(0);

  useEffect(() => {
    if (
      productItems[0]?.flowwwId &&
      productItems[0].title.toLowerCase().indexOf('peeling químico') > -1
    ) {
      setFlipMessage(
        'Tratamiento no válido para meses de verano. Consulta con atención al cliente.'
      );
    }
  }, [productItems]);

  useEffect(() => {
    const frontPriceCard = document.getElementById(`frontPriceCard`);

    if (frontPriceCard) {
      setCardHeight(frontPriceCard.clientHeight);
    }
  }, []);

  return (
    <ReactCardFlip
      isFlipped={isFlipped}
      flipDirection="horizontal"
      containerClassName="w-full md:w-1/2 relative"
    >
      <Flex
        id={`frontPriceCard`}
        layout="col-left"
        className={`md:flex-row md:gap-8 w-full ${className}`}
      >
        {flipMessage && (
          <div
            className="absolute top-6 right-6 bg-derma-secondary300 rounded-full p-2 text-hg-secondary shrink-0 aspect-square flex justify-center items-center cursor-pointer"
            onClick={() => setIsFlipped(!isFlipped)}
          >
            <SvgInfoCircle className="h-6 w-6" />
          </div>
        )}
        <Flex
          layout="col-left"
          className={`bg-white p-6 rounded-2xl w-full shadow-centered-secondary md:shadow-none ${
            isGroupedSessionProduct ? '' : isDashboard ? 'w-2/3' : ''
          }`}
        >
          {!isDashboard && (
            <Text className="text-2xl font-semibold text-hg-secondary mb-4">
              {productItems[productIndexToAdd].price} €
            </Text>
          )}
          <ul className="flex flex-wrap gap-2 mb-4">
            {productItems.map((product: Product, index: number) => {
              return (
                <Button
                  size="sm"
                  type={productIndexToAdd === index ? 'secondary' : 'white'}
                  customStyles={
                    productIndexToAdd === index
                      ? ''
                      : 'border-none bg-derma-secondary300 font-normal'
                  }
                  key={product.sessions}
                  onClick={() => setProductIndexToAdd(index)}
                >
                  {product.sessions}{' '}
                  {product.sessions === 1 ? 'sesión' : 'sesiones'}
                </Button>
              );
            })}
          </ul>

          <Text className="font-semibold text-lg mb-2">
            {
              SESSION_PRODUCTS_EXTRA_INFO.filter(
                item => item.id === productItems[productIndexToAdd].id
              )[0]?.title
            }
          </Text>

          {SESSION_PRODUCTS_EXTRA_INFO.filter(
            item => item.id === productItems[productIndexToAdd].id
          )[0]?.description && (
            <Text className="text-hg-black500 text-sm mb-12">
              {
                SESSION_PRODUCTS_EXTRA_INFO.filter(
                  item => item.id === productItems[productIndexToAdd].id
                )[0]?.description
              }
            </Text>
          )}

          {SESSION_PRODUCTS_EXTRA_INFO.filter(
            item => item.id === productItems[productIndexToAdd].id
          )[0]?.bullets && (
            <ul className="text-hg-black500 text-sm mb-12 flex flex-col gap-2">
              {SESSION_PRODUCTS_EXTRA_INFO.filter(
                item => item.id === productItems[productIndexToAdd].id
              )[0]?.bullets?.map(bullet => (
                <li key={bullet} className="flex w-full gap-2 justify-sta">
                  <SvgCheckCircle className="text-hg-secondary h-4 w-4 shrink-0" />
                  <p
                    className="text-start"
                    dangerouslySetInnerHTML={{ __html: bullet }}
                  />
                </li>
              ))}
            </ul>
          )}

          {isDashboard ? (
            <Flex
              layout="row-between"
              className="bg-derma-secondary300 p-2 rounded-full w-full"
            >
              <Text className="text-2xl font-semibold text-hg-secondary pl-2">
                {productItems[productIndexToAdd].price} €
              </Text>
              <Quantifier
                isSmall
                handleUpdateQuantity={function handleUpdateQuantity(
                  operation: Operation
                ): void {
                  if (operation == 'increase') {
                    addItemToCart(productItems[productIndexToAdd] as CartItem);
                  } else {
                    removeSingleProduct(
                      productItems[productIndexToAdd] as CartItem
                    );
                  }
                  setBudgetId('');
                }}
                quantity={getQuantityOfProduct(productItems[productIndexToAdd])}
              />
            </Flex>
          ) : (
            <Button
              type="primary"
              className=""
              onClick={() => {
                cleanCheckoutSession();
                setSelectedTreatments([productItems[0]]);
                if (
                  productItems[productIndexToAdd].type === ProductType.Esthetic
                ) {
                  addItemToCart(productItems[productIndexToAdd] as CartItem);
                }
                ProductRedirect(
                  productItems[productIndexToAdd],
                  router,
                  cart,
                  currentOrigin
                );
              }}
            >
              Me interesa
              <SvgArrow height={16} width={16} className="ml-2" />
            </Button>
          )}
        </Flex>
      </Flex>
      <div className="h-full flex w-full">
        {flipMessage && (
          <div
            className="bg-hg-secondary text-white rounded-2xl  flex flex-col items-start gap-4 p-6 w-full"
            style={{ minHeight: `${cardHeight}px`, height: `${cardHeight}px` }}
          >
            <div
              className="bg-white rounded-full p-2 text-hg-secondary shrink-0 aspect-square flex justify-center items-center self-end cursor-pointer"
              onClick={() => setIsFlipped(!isFlipped)}
            >
              <SvgCross className="h-4 w-4" />
            </div>

            <p className="md:text-lg font-semibold mb-auto">{flipMessage}</p>

            <Button
              type="white"
              onClick={() => setIsFlipped(!isFlipped)}
              customStyles="border-0 text-hg-secondary"
            >
              <SvgArrow className="rotate-180 h-4 w-4 mr-2" />
              Volver
            </Button>
          </div>
        )}
      </div>
    </ReactCardFlip>
  );
}
